import { UPDATE_LAST_EXECUTED_STAGE, FLUSH_QUERY } from "../../actions/QueryBuilder/actionConstants";

const lastExecutedStageReducer = (state = -1, action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type,
		 *  updatedLastExecutedStage
		 * }
		 */
		case UPDATE_LAST_EXECUTED_STAGE:
			return action.updatedLastExecutedStage;
		case FLUSH_QUERY:
			return -1;
		default:
			return state;
	}
};

export default lastExecutedStageReducer;
